import React from "react";
import clsx from "clsx";
import { useParams } from "react-router-dom";

import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Container from "@material-ui/core/Container";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import MenuItems from "../../components/MenuItems";
import Charts from "../../components/Charts";
import useStyles from "./style";
import { Questions } from "./Questions";
import { Areas } from "./Areas";
import { Charges } from "./Charges";
import { Competences } from "./Competences";

export default function Admin() {
  const classes = useStyles();
  const params = useParams();
  const { section } = params;
  const [open, setOpen] = React.useState(true);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const renderTitle = () => {
    return {
      areas: "Areas",
      charges: "Cargos",
      dashboard: "Resultados",
      questions: "Preguntas",
      users: "Usuarios",
      competences: "Competencias",
    }[section || "dashboard"];
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="absolute"
        className={clsx(classes.appBar, open && classes.appBarShift)}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(
              classes.menuButton,
              open && classes.menuButtonHidden
            )}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            {renderTitle()}
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <MenuItems />
        <Divider />
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          {(!section || section === "dashboard") && <Charts />}
          {section && section === "questions" && <Questions />}
          {section && section === "areas" && <Areas />}
          {section && section === "charges" && <Charges />}
          {section && section === "competences" && <Competences />}
        </Container>
      </main>
    </div>
  );
}
